// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import FlashController from "./flash_controller"
application.register("flash", FlashController)

import HabitFormController from "./habit_form_controller"
application.register("habit-form", HabitFormController)

import HabitsSortController from "./habits_sort_controller"
application.register("habits-sort", HabitsSortController)

import NumberSaveController from "./number_save_controller"
application.register("number-save", NumberSaveController)

import DurationSaveController from "./duration_save_controller"
application.register("duration-save", DurationSaveController)

import OfflineController from "./offline_controller"
application.register("offline", OfflineController)

import BackfillCalendarController from "./backfill_calendar_controller"
application.register("backfill-calendar", BackfillCalendarController)

import FastingController from "./fasting_controller"
application.register("fasting", FastingController)

import MacroEntryController from "./macro_entry_controller"
application.register("macro-entry", MacroEntryController)
